import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, FormGroupDirective, Validators } from "@angular/forms";
import { DynamicControl } from "../interfaces/DynamicControl";
import { DynamicFormConfig } from "../types/dynamic-form-config";
import { ServidorService } from "../../../service/servidor/servidor.service";
import { DadosExcecoesService } from "../../../service/dados-excecoes/dados-excecoes.service";

@Component({
  selector: 'app-auto-complete-servidor',
  templateUrl: './auto-complete-servidor.component.html',
  viewProviders: [{
    provide: ControlContainer,
    useExisting: FormGroupDirective
  }],
  styleUrls: ['./auto-complete-servidor.component.sass']
})
export class AutoCompleteServidorComponent implements OnInit, DynamicControl {

  config: DynamicFormConfig;
  filteredOptionsServidor: any[] = [];
  optionsServidor: any[] = [];
  matricula: number;
  form: FormGroup;

  constructor(private servidorService: ServidorService, private controlContainer: ControlContainer) {
  }
  ngOnInit(): void {
    this.form = this.controlContainer.control as FormGroup;
    this.initAutoCompleteServidor();
  }

  public onOptionSelectedServidor(option: any): void {
    this.form.get(this.config.name[0]).setValue(`${option.matricula} - ${option.nome}`);
    this.matricula = option.matricula;
  }

  private initAutoCompleteServidor() {
    this.form.get(this.config.name[0]).valueChanges
      .subscribe((servidor) => {
        if (servidor && servidor.length >= 3 && this.form.get(this.config.name[0]) != servidor) {
          this.onInputChange();
        }
      });
  }

  onInputChange() {
    let value = this.form.get(this.config.name[0]).value;
    if (value) {
      this.servidorService.getServidor(value).subscribe(
        (response) => {
          this.optionsServidor = response.content;
          this.filteredOptionsServidor = this.optionsServidor.filter((option) =>
            option.nome.toLowerCase().includes(value.toLowerCase()) || option.matricula.toString().includes(value.toLowerCase())
          );
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.optionsServidor = [];
      this.filteredOptionsServidor = [];
    }
  }

}
